<template>
    <div>
        <div class="relative find-a-stockist col-lg-10 col-md-8">
            <span class="title">Enter your suburb or postcode to find your nearest stockist</span>

            <ProductAvailabilityList 
                :show="1"
                :preview="true"
                @change-stockist="changeStockist"
            ></ProductAvailabilityList>
        </div>
    </div>
  </template>
    
  <script>
    import ProductAvailabilityList from './ProductAvailabilityList.vue';
    import axios from 'axios';

    const AJAX_URL = '/wp-admin/admin-ajax.php';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

    export default {
        name: 'FindStockist',
        components: {
            ProductAvailabilityList
        },
        methods: {
            changeStockist: function (id) {
                document.querySelector("pp-overlay").setAttribute( 'show', "true");

                /**
                 * Update the selected store in WC session & refresh the side cart fragment
                 */
                axios.post(AJAX_URL, {
                    action: 'ajax_cart_change_stockist',
                    key: 'selected-store',
                    value: id
                }).then(function () {
                    axios.post('/?wc-ajax=get_refreshed_fragments').then(function (response) {
                        const cart_content = document.querySelector('div.widget_shopping_cart_content');

                        if (cart_content) {
                            cart_content.outerHTML = response.data['fragments']['div.widget_shopping_cart_content'];
                        }
                        
                        console.log("before set attribute for pp-overlay");
                        document.querySelector("pp-overlay").setAttribute( 'show', "false");
                        console.log("after set attribute for pp-overlay");

                    })
                })
            },
        }
    }
  </script>

<style lang="scss" scoped>
@import "@/assets/global.scss";

.find-a-stockist {
    padding: 20px;
    margin: auto;
    border: 1px solid #D3D2D2;
    border-radius: 4px;
    margin-bottom: 40px;

    .title {
        text-align: center;
    }
}

@media (min-width: 1025px) {
    .col-lg-10 {
        flex: 0 0 83.333333%;
        max-width: 83.333333%;
    }
}

@media (min-width: 769px) {
    .col-md-8 {
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }
}

</style>